/*
 * Products Landing search is a variation on text autocomplete implementations, except that a search query
 * will produce a hash set of matching product Ids instead of matching search terms. A product will match
 * if all typed search terms are prefixes for words in the product name. Implemented using a variation on a
 * Trie data structure.
 */
const getSearchableProducts = (products, searchableFields = ['brandName', 'genericName']) => {
  const rootNode = {
    productIds: [],
    children: {}
  }

  products
    .forEach(product => searchableFields
    .forEach(field => _getSearchableWords(product[field])
    .forEach(word => _addProduct(rootNode, product.id, word))))

  return rootNode
}

const _getSearchableWords = (text) => {
  if (text) {
    return text.toUpperCase().replace(/[()\[\]®™]/g, '').replace(/É/g, 'E').trim().split(/\s+/)
  }
  return []
}

const _addProduct = (node, productId, word, wordIndex = 0) => {
  if (!word[wordIndex]) {
    node.productIds.push(productId)
    return
  }

  const firstLetter = word[wordIndex]
  if (!node.children[firstLetter]) {
    node.children[firstLetter] = {
      productIds: [],
      children: {}
    }
  }
  _addProduct(node.children[firstLetter], productId, word, wordIndex + 1)
}

const productSearch = (query, searchableProducts, displayedProducts) => {
  let filteredProducts = null
  if (query) {
    const searchCriteria = _getSearchableWords(query)
    const productIdResults = []
    // Returns a hash set of product Ids for every word included in the search criteria
    searchCriteria.forEach(word => productIdResults.push(_search(searchableProducts, word)))
  
    // A product will be shown if every searched word returned a result for that product Id
    filteredProducts = displayedProducts.filter(p => productIdResults.every(productIds => p.id in productIds))
  }
  return filteredProducts
}
  
const _search = (node, query, queryIndex = 0) => {
  if (!query[queryIndex]) {
    return _getSearchResults(node)
  }
  const firstLetter = query[queryIndex]
  if (node.children[firstLetter]) {
    return _search(node.children[firstLetter], query, queryIndex + 1)
  }

  return {}
}

const _getSearchResults = (node) => {
  const results = {}
  node.productIds.forEach(id => results[id] = true)
  Object.keys(node.children).forEach(key => Object.assign(results, _getSearchResults(node.children[key])))
  return results
}

export { getSearchableProducts, productSearch }


// WEBPACK FOOTER //
// ./src/mi-app/products/util/productSearchUtil.js